module.exports = "/static/assets/061d7919139982a9ee5541ac498d4828.gif";